<template>
<div class='dashboard'>
  <el-row>
    <el-col :span="16" :offset="1" class='project-created-data'>
      <div class='select-bar'>
        <span>{{$t('createProjectNum')}}</span>
        <el-select class='select-box' v-model="projectsCreatedPeriod" :placeholder="$t('common.placeholder.plzChoose')">
          <el-option v-for="p in periods" :key="p" :label="$t(`periods.past`) + $t(`periods.${p}`)" :value="p">
          </el-option>
        </el-select>
      </div>
      <line-chart class='pv-chart' :data="projectsCreatedData" :min="0" :library="projectsCreatedChartOptions"></line-chart>
    </el-col>
    <el-col :span="5" :offset="1" class='summary'>
      <div class='item blue'>
        <p class='number'>{{quotas.members}}</p>
        <p class='title' v-once>{{$t('packageAccountsTotalNum')}}</p>
      </div>
      <div class='item orange'>
        <p class='number'>{{summary.projects}}</p>
        <p class='title' v-once>{{$t('projectsTotalNum')}}</p>
      </div>
      <div class='item green'>
        <p class='number'>{{summary.pv}}</p>
        <p class='title' v-once>{{$t('projectsTotalPV')}}</p>
      </div>
      <!-- <div class='item red'>
        <p class='number'>{{summary.members}}</p>
        <p class='title' v-once>{{$t('packageAccountsUsedNum')}}</p>
      </div> -->
    </el-col>
  </el-row>
  <el-row>
    <el-col :span="22" :offset="1">
      <p style="font-weight: 600;margin: 2em 1em;" v-once>{{$t('recentCreateProjectList')}}</p>
      <el-table :data="recentProjects" class='recent-projects' stripe>
        <el-table-column prop="name" :label="$t('projectName')">
        </el-table-column>
        <el-table-column prop="user.nickname" :label="$t('projectCreator')">
        </el-table-column>
        <el-table-column :label="$t('projectCreatedDate')">
          <template scope="scope">
            <span>{{ dateReadable(scope.row.created_at) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="pv" :label="$t('projectPV')">
        </el-table-column>
        <el-table-column :label="$t('common.tablehead.action')">
          <template scope="scope">
            <a @click="projectDialog(scope.row)" class='text-btn'>
                <span v-once>{{$t('seeAndShare')}}</span>
            </a>
          </template>
        </el-table-column>
      </el-table>
    </el-col>
  </el-row>
</div>
</template>

<i18n>
{
  "zh-cn": {
    "createProjectNum": "创建@:common.project数",
    "packageAccountsTotalNum": "套餐内账号总数",
    "projectsTotalNum": "@:common.project总数",
    "projectsTotalPV": "@:common.project浏览次数",
    "packageAccountsUsedNum": "当前账号总数",
    "recentCreateProjectList": "最近创建@:common.project",
    "projectName": "@:common.project名称",
    "projectNum": "@:common.project数：",
    "projectCreator": "创建人",
    "projectCreatedDate": "创建日期",
    "projectPV": "浏览人次",
    "seeAndShare": "查看及分享",
    "periods": {
      "past": "过去",
      "week": "一周",
      "month": "一个月",
      "season": "三个月",
      "year": "一年"
    }
  }
}
</i18n>

<script>
import { dynamicImportChartkick } from '@/assets/scripts/charts'
import { createDialog } from '@/assets/scripts/dialog'
import ProjectDialog from './project.dialog'

export default {
  data() {
    return {
      projectsCreatedData: null,
      projectsCreatedPeriod: 'week',
      granularity: 'day',
      summary: {},
      quotas: {},
      periods: ['week', 'month', 'season', 'year'],
      recentProjects: [],
      projectDialog: createDialog(ProjectDialog)
      // currentPage: 1
    }
  },
  watch: {
    projectsCreatedPeriod: function(newValue) {
      this.fetch()
    }
  },
  computed: {
    projectsCreatedChartOptions() {
      let vm = this

      return {
        tooltips: {
          callbacks: {
            // title: (item, data) => { return item.yLabel.toString() },
            label: (item, data) => {
              return vm.$t('projectNum') + item.yLabel.toString()
            }
          }
        },
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              displayFormats: {
                day: 'MM-DD',
                week: 'wo',
                month: 'MMM'
              },
              isoWeekday: true, // 'true' would start with 'Monday', 'false' would start with 'Sunday'
              unit: vm.granularity,
              stepSize: vm.projectsCreatedPeriod === 'month' ? null : 1,
              tooltipFormat: (vm.granularity === 'month' ? 'YYYY-MM' : 'YYYY-MM-DD')
            }
          }]
        }
      }
    }
  },
  components: {
    'line-chart': () => dynamicImportChartkick('LineChart')
  },
  methods: {
    fetch() {
      let vm = this
      vm.loading = true
      vm.$store.dispatch('organization/stats', {
        orgId: vm.organization.id,
        period: vm.projectsCreatedPeriod
        // page: vm.currentPage || 1
      }).then(res => {
        // vm.currentPage = res.data.current_page
        vm.projectsCreatedData = res.data.projects_created.data
        vm.granularity = res.data.projects_created.granularity
        vm.summary = res.data.summary
        vm.quotas = res.data.quotas
        vm.recentProjects = res.data.recent_projects
        // vm.projects_created_data = data.
        // vm.totalPages = res.data.total_pages
        // vm.totalItems = res.data.total_items
        // vm.pageSize = res.data.page_size
        vm.loading = false
      })
    }
  },
  mounted() {
    this.fetch()
  }
}
</script>

<style lang="scss">
.dashboard {
    .project-created-data {
        padding: 3em;
        height: 31em;
        background-color: $color-white-base;

        .select-bar {
            overflow: hidden;
            margin-bottom: 2em;

            .select-box {
                float: right;
            }
        }
    }

    .summary {
        padding: 0;
        .item {
            width: 100%;
            height: 9em;
            background-color: black;
            color: $color-white-base;
            text-align: center;
            overflow: hidden;
            margin-bottom: 2em;
            padding-top: 1em;

            .number {
                font-size: 2em;
                margin: 0.5em 0;
                font-weight: 600;
            }
            .title {
                margin: 0;
                font-size: 0.9em;
            }

            &.blue {
                background-color: #589FEE;
            }

            &.orange {
                background-color: #F79264;
            }

            &.green {
                background-color: #11CECF;
            }

            &.red {
                background-color: #F8686B;
            }
        }
    }

    .recent-projects {
        th .cell {
            font-weight: normal;
        }

        .cell {
            padding-left: 0.5em;
        }

        .el-table__body tr td {
            background: $color-gray-index-background;
        }
        &.el-table--striped .el-table__body tr.el-table__row--striped td {
            background: $color-white-base;
        }

        col[name="el-table_1_column_2"] {
            width: 60px;
        }
        col[name="el-table_1_column_3"] {
            width: 100px;
        }
        col[name="el-table_1_column_4"] {
            width: 60px;
        }
        col[name="el-table_1_column_5"] {
            width: 60px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// index.vue?56790b79